import React from "react";
import styles from "./CustomInput.module.scss";

const CustomInput = ({
  placeholder,
  label,
  error,
  width = "100%",
  ...props
}) => {
  return (
    <div className={styles.inputContainer} style={{ width: width }}>
      <label className={styles.label}>
        {label} <span className={styles.error}> {error}</span>
      </label>
      <input
        type="text"
        placeholder={placeholder}
        className={styles.input}
        {...props}
      />
    </div>
  );
};

export default CustomInput;
